<template>
  <div>
    <div
      class="d-flex justify-content-between mt-2 ts-m-auto"
      style="width: 90%"
    >
      <div class="ts-text-xs ts-whitespace-normal ts-w-1/2">
        {{
          $t(
            'school.academic.setup.program.subject.core_subjects.component_items'
          )
        }}
      </div>
      <div class="ts-text-xs ts-ml-2">
        <input
          type="number"
          step="any"
          v-model.number="scoreInput"
          @input="onScoreInputChange"
          class="form-items"
          style="width: 90%"
          :placeholder="
            $t('school.academic.setup.program.subject.core_subjects.max_score')
          "
        />
      </div>
      <div>
        <a
          href="#"
          v-tooltip="
            $t('school.academic.setup.program.subject.core_subjects.add_items')
          "
          @click.prevent="addComponentItem"
        >
          <i class="far fa-plus-square"></i>
        </a>
      </div>
    </div>
    <table style="width: 85%" class="ts-m-auto">
      <!-- <draggable tag="tbody" v-model="datatable"> -->
      <tr v-for="(item, index) in datatable" :key="index">
        <td style="padding: 2px 8px 3px 0">
          <input
            v-model.trim="item.subject_comp_item_detail_name"
            type="text"
            class="form-items"
            style="width: 100%"
            :placeholder="
              $t(
                'school.academic.setup.program.subject.core_subjects.item_name'
              )
            "
          />
        </td>
        <td style="padding: 2px 8px 3px 0">
          <input
            :value="item.max_score"
            type="text"
            class="form-items"
            style="width: 100%"
          />
        </td>
        <td style="width: 10px" valign="middle">
          <a href="#" class="text-danger" @click.prevent="removeItem(item)">
            <i class="fas fa-times"></i>
          </a>
        </td>
      </tr>
      <!-- </draggable> -->
    </table>
  </div>
</template>

<script>
// import draggable from 'vuedraggable'

export default {
  name: 'component-items',
  props: ['value', 'index'],
  components: {
    // draggable
  },
  data () {
    return {
      datatable: [],
      loading: false,
      scoreInput: '',
      model: {
        component_list:
          this.editData && this.editData.component_list
            ? this.editData.component_list.map(comp => ({
                component_items: comp.component_items.map(item => ({
                  max_score: item.max_score
                }))
              }))
            : [],
        is_elective_subject_parent: this.editData
          ? this.editData.is_elective_subject_parent
            ? true
            : false
          : false
      }
    }
  },

  methods: {
    removeItem (item) {
      if (item.subject_comp_detail_id === 0) {
        this.datatable.splice(this.datatable.indexOf(item), 1)
        return
      }

      this.$store
        .dispatch(
          'subjectCore/removeComponentItems',
          item.subject_comp_detail_id
        )
        .then(response => {
          this.$toasted.success(response.message)
          this.datatable.splice(this.datatable.indexOf(item), 1)
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },

    addComponentItem () {
      this.datatable.push({
        subject_comp_detail_id: 0,
        subject_comp_id: '',
        subject_comp_item_detail_name: null,
        max_score: null,
        display_order: this.datatable.length
      })
    },
    pushToDatatable () {
      this.datatable = []
      this.value.forEach(data => {
        let detail = Object.assign({}, this.newItem, data, {
          subject_comp_detail_id: data.subject_comp_detail_id,
          subject_comp_id: data.subject_comp_id,
          subject_comp_item_detail_name: data.subject_comp_item_detail_name,
          max_score: data.max_score,
          display_order: data.display_order
        })
        this.$nextTick(() => {
          this.datatable.push(detail)
        })
      })
    },
    onScoreInputChange () {
      this.datatable.forEach(el => {
        el.max_score = this.scoreInput
      })
    }
  },
  watch: {
    value: {
      handler (val) {
        if (_.isEqual(val, this.datatable)) return

        this.pushToDatatable()
      },
      deep: true,
      immediate: true
    },

    datatable: {
      handler (val) {
        if (_.isEqual(val, this.value)) return

        this.$emit('input', val)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.form-items {
  border: 1px solid #d3d8de;
  outline: none !important;
  padding: 3px 7px;
  border-radius: 3px;
}
</style>
